import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../assets/img/logo_profit_insights.png";
import AssessmentDistribuidores from "../views/Assessment/AssessmentDistribuidores";
import {
  FloatingToolbar,
  LanguageToolbarItem,
} from "../components/FloatingToolbar";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    padding: "15px 30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    [theme.breakpoints.down("sm")]: {
      padding: "10px 15px",
    },
  },
  logo: {
    height: "40px",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      height: "30px",
    },
  },
  content: {
    flex: 1,
    marginTop: "70px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "60px",
    },
  },
}));

export default function Assessment() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FloatingToolbar>
        <LanguageToolbarItem />
      </FloatingToolbar>
      <div className={classes.header}>
        <img src={logo} alt="Profit InSights" className={classes.logo} />
      </div>
      <div className={classes.content}>
        <Routes>
          <Route
            path="/distribuidores"
            element={<AssessmentDistribuidores />}
          />
          <Route
            path="/"
            element={<Navigate to="/assessment/distribuidores" replace />}
          />
        </Routes>
      </div>
    </div>
  );
}
